const captcha = {
  image: null,
  hidden: null,
  error: null,
  warning: null,
  success: null,
  statusModal: false,
};

const getters = {
  GET_CAPTCHA(state) {
    return {
      image: state.image,
      hidden: state.hidden,
      id: state.id,
    };
  },
  GET_WARNING(state) {
    return state.warning;
  },
  GET_ERROR(state) {
    return state.error;
  },
  GET_SUCCESS(state) {
    return state.success;
  },
  GET_STATUS_MODAL(state) {
    return state.statusModal;
  },
};
const mutations = {
  RESET(state) {
    state.image = null;
    state.hidden = null;
    state.id = null;
    state.warning = null;
    state.error = null;
    state.success = null;
  },
  SET_CAPTCHA(state, data) {
    state.image = data.image;
    state.hidden = data.hidden;
    state.id = data.id;
  },
  SET_WARNING(state, data) {
    state.warning = data;
  },
  SET_ERROR(state, data) {
    state.error = data;
  },
  SET_SUCCESS(state, data) {
    state.success = data;
  },
  SET_STATUS_MODAL(state, data) {
    state.statusModal = data;
  },
};

const actions = {
  reset({ commit }) {
    commit('RESET');
  },
  setCaptcha({ commit }, data) {
    commit('SET_CAPTCHA', data);
  },
  setWarning({ commit }, data) {
    commit('SET_WARNING', data);
  },
  setError({ commit }, data) {
    commit('SET_ERROR', data);
  },
  setSuccess({ commit }, data) {
    commit('SET_SUCCESS', data);
  },
  openModal({ commit }) {
    commit('SET_STATUS_MODAL', true);
  },
  closeModal({ commit }) {
    commit('SET_STATUS_MODAL', false);
  },
};

export default {
  namespaced: true,
  state: captcha,
  getters,
  mutations,
  actions,
};
